
// Internal dependencies
import HTDMath from './htd-math';

export default HTDMath;
